const ReferralHero = () => {
  return (
    <div className='flex flex-col gap-3 px-5 pt-8 pb-8 md:px-10 md:pt-10 md:pb-10'>
      <h1 className='text-brand-1100 text-2xl font-normal xl:text-3xl'> Points and Referral</h1>
      <p className='w-full text-base leading-6 font-normal text-gray-400'>
        Mezzanine Points track early participation. Earn them by holding tranche tokens, and grow them through
        referrals. Join with a friend’s code and your own deposit earns 10% more points. Share your own link and
        Mezzanine pays you a bonus worth 10% of the points your friends earn, for as long as they hold tranche tokens.
        No cap, no deposit needed to invite, one permanent code per wallet. Tracked by Merkl and updated regularly.
      </p>
    </div>
  );
};

export default ReferralHero;
